import { Stack, styled } from '@mui/material';

import { forMobile, theme } from '@/shared/design-system';

/**
 * Pinned to the bottom of the scrolling page while a draft is open, so the way out (discard or
 * review) is always in reach however far down the catalogue the edit happened.
 */
export const SaveBarRoot = styled('div')({
  position: 'sticky',
  bottom: theme.spacing[16],
  zIndex: 2,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[16],
  padding: `${theme.spacing[12]}px ${theme.spacing[16]}px`,
  borderRadius: theme.radius[12],
  backgroundColor: theme.colors.background.raised,
  border: `1px solid ${theme.colors.border.default}`,
  boxShadow: theme.shadows.lg,

  [forMobile]: {
    bottom: theme.spacing[8],
    flexWrap: 'wrap',
    gap: theme.spacing[8],
  },
});

export const SaveBarText = styled(Stack)({
  flexDirection: 'column',
  flex: '1 1 160px',
  gap: theme.spacing[2],
  minWidth: 0,
});

export const SaveBarActions = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],
  flexShrink: 0,
  marginLeft: 'auto',
});

export const ReviewBody = styled(Stack)({
  flexDirection: 'column',
  gap: theme.spacing[16],
});

export const ChangeList = styled(Stack)({
  flexDirection: 'column',
  maxHeight: '320px',
  overflowY: 'auto',
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.radius[12],
});

export const ChangeRow = styled('div')({
  display: 'grid',
  gridTemplateColumns: `${theme.spacing[16]}px 1fr auto`,
  alignItems: 'start',
  gap: theme.spacing[8],
  padding: `${theme.spacing[12]}px`,

  '& + &': {
    borderTop: `1px solid ${theme.colors.border.default}`,
  },
});

export const ChangeSign = styled('span', {
  shouldForwardProp: (prop) => prop !== '$added',
})<{ $added: boolean }>(({ $added }) => ({
  fontFamily: theme.typography.fontFamily.mono,
  fontWeight: 500,
  color: $added ? theme.colors.brand.text : theme.colors.error.text,
}));

export const ChangeText = styled(Stack)({
  flexDirection: 'column',
  gap: theme.spacing[2],
  minWidth: 0,
});
